function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#247dbd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M15.187,6.064,3.663,16.226a2.44,2.44,0,0,1-.288.177v9.753A.844.844,0,0,0,4.218,27H26.156A.844.844,0,0,0,27,26.156v-9.75a2.46,2.46,0,0,1-.277-.169Zm5.062,13.763a.422.422,0,0,1-.422.422H16.874V23.2a.422.422,0,0,1-.422.422H13.921A.422.422,0,0,1,13.5,23.2V20.249H10.546a.422.422,0,0,1-.422-.422V17.3a.422.422,0,0,1,.422-.422H13.5V13.921a.422.422,0,0,1,.422-.422h2.531a.422.422,0,0,1,.422.422v2.953h2.953a.422.422,0,0,1,.422.422Zm9.845-7.368L16.6.542a2.1,2.1,0,0,0-2.819,0L.279,12.46a.844.844,0,0,0-.064,1.192l1.129,1.256a.844.844,0,0,0,1.192.064L14.629,4.3a.844.844,0,0,1,1.116,0L27.838,14.971a.844.844,0,0,0,1.192-.064l1.128-1.256a.844.844,0,0,0-.064-1.191Z",
  transform: "translate(0.001 0.001)"
});

const SvgIconGrupo = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.375,
    height: 27,
    viewBox: "0 0 30.375 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGrupo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_Grupo.feaceba3.svg";
export { ForwardRef as ReactComponent };